import {Injectable} from '@angular/core';
import {ResponseArray} from '@shared/interfaces/http.interface';
import {API_ORGANIZATIONAL_UNITS_RISK_NOTE, getEndpoint} from '@core/constants/api';
import {OrganizationalUnitRiskRating} from '@core/interfaces/risk-rating/organizational-unit-risk-rating.interface';
import {OrganizationalUnitRiskNoteParams} from '@core/interfaces/risk-rating/organizational-unit-risk-rating-params';
import {HttpHelper} from '@shared/helpers/http.helper';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrganizationalUnitRiskNoteService extends HttpHelper {
  getList(params: OrganizationalUnitRiskNoteParams): Promise<ResponseArray<OrganizationalUnitRiskRating>> {
    const { year, organization_units } = params;
    let httpParams: HttpParams = new HttpParams();

    httpParams = httpParams.append('year', year);
    httpParams = httpParams.append('ids', organization_units.join(','));

    return this.GetAll<OrganizationalUnitRiskRating>(
      getEndpoint(API_ORGANIZATIONAL_UNITS_RISK_NOTE), {params: httpParams},
    );
  }
}
